import React from 'react';
import './Layout.css';
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuthorisation } from '../LoginPage/AuthorisationProvider';
import fridgeIcon from "../../Images/fridgeicon.png"
import panIcon from "../../Images/panicon.png"
import calendarIcon from "../../Images/calendaricon.png"
import listIcon from "../../Images/list.png"
import logoutIcon from "../../Images/logouticon.png"

function Layout() {
    const navigate = useNavigate();
    const currentPage = useLocation().pathname;
    const authorisation = useAuthorisation();
    return (
        <div className="Layout">
            <header className="Layout-header">
                <nav id="navigation-bar" className="nav-bar">
                    <div id="navigation-list" className="nav-list" >
                        <div className={currentPage === "/IngredientList" ? "nav-element active" : "nav-element"} onClick={() => navigate("/IngredientList")}>
                            <p className="nav-bar-large-text">Ingredients</p>
                            <img className="nav-bar-icon" src={fridgeIcon} alt="Ingredients"/>
                        </div>
                        <div className={currentPage === "/RecipeList" ? "nav-element active" : "nav-element"} onClick={() => navigate("/RecipeList")}>
                            <p className="nav-bar-large-text">Recipes</p>
                            <img className="nav-bar-icon" src={panIcon} alt="Recipes"/>
                        </div>
                        <div className={currentPage === "/PlanList" ? "nav-element active" : "nav-element"} onClick={() => navigate("/PlanList")}>
                            <p className="nav-bar-large-text">Planner</p>
                            <img className="nav-bar-icon" src={calendarIcon} alt="Planner"/>
                        </div>
                        <div className={currentPage === "/ShoppingList" ? "nav-element active" : "nav-element"} onClick={() => navigate("/ShoppingList")}>
                            <p className="nav-bar-large-text">Shopping List</p>
                            <img className="nav-bar-icon" src={listIcon} alt="Shopping List"/>
                        </div>
                        <div className="gap-div"></div>
                        <div className="nav-element logout right-justified" onClick={() => authorisation.logoutAction()} >
                            <p className="nav-bar-large-text">Log Out</p>
                            <img className="nav-bar-icon" src={logoutIcon} alt="Log Out"/>
                        </div>
                    </div>
                </nav>
            </header>
            <div className="page-layout">
                <Outlet />
            </div>
        </div>
    );
}

export default Layout;